export default "const one_day: int = 86_400;\n// Type your solution below\nconst eta: timestamp = Tezos.get_now() + 6 * one_day;\n\n";